<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2024-01-03 16:26:52
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-16 14:30:42
 * @FilePath: /gamefi/components/Casino/History/GameDetaliModal/Fairness.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div
        class="bg-grey-100 rounded-2xl p-3 transition-all duration-500 overflow-hidden"
        :class="[collapsed ? 'h-[272px] sm:h-[328px]' : 'h-12']"
    >
        <div class="flex items-center justify-between cursor-pointer"
            @click="onCollapse"
        >
            <div class="flex items-center gap-1">
                <IconSvgUse class="w-6 h-6" use="icon-book" />
                <span class="text-white">{{ t.Fainess }}</span>
            </div>
            <QIcon class="text-white" :name="collapsed ? 'arrow_drop_up' : 'arrow_drop_down'" />
        </div>
        <!-- ↑ 顶部标题 -->
        <!-- ↓ 其它信息（默认收起） --> 
        <div class="mt-2 flex flex-col gap-2">
            <div class="flex flex-col gap-1">
                <div class="text-grey-40">{{ t.RandomSeed }}</div>
                <Input readonly :model-value="oFairnessData.randomSeed" @click="handleSelectAll">
                    <template v-slot:append>
                        <ButtonCopy class="bg-grey-60" :value="oFairnessData.randomSeed" />
                    </template>
                </Input>
            </div>
            <!-- ↑ randomSeed --> 
            <!-- ↓ hash --> 
            <div class="flex flex-col gap-1">
                <div class="text-grey-40">{{ t.HashRound }}</div>
                <Input readonly :model-value="oFairnessData.hash" @click="handleSelectAll">
                    <template v-slot:append>
                        <ButtonCopy class="bg-grey-60" :value="oFairnessData.hash" />
                    </template>
                </Input>
            </div>
        </div>

        <div class="flex sm:flex-col mt-3 gap-3 w-auto justify-center">
            <Button @click="onHowItWorks" mode="normal" class="bg-grey-60 text-textFade flex-1">
                {{ t.FairnessPrinciple }}
            </Button>
            <Button @click="onCheck" mode="normal" class="bg-grey-60 text-textFade flex-1">
                {{ t.GameDetails.CheckFairness }}
            </Button>
        </div>
    </div>
</template>


<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const collapsed = ref(false);
const emit = defineEmits(['handlePrinciple']);
const onCollapse = () => {
    collapsed.value = !collapsed.value;
};

const props = defineProps({
    history: { // 默认项
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
    fairness: { // 首选项，特殊游戏会用到，如 Hilo 
        type: Object,
    },
    fnScrollMove: { 
        type: Function,
    },
    currentIndex: {
        type: Number,
        default: 0
    }
});

const oFairnessData = computed(()=>{
    if (props.fairness){
        const oResult = deepCopy(props.fairness);
        oResult.randomSeed ||= oResult.random_seed;
        return oResult;
    }
    // coinflip multiply模式下
    if (props.history?.gameId === 4 && !props.history?.single){
        return props.history?.state.map(item => ({
            ...item,
            randomSeed: item.seed
        }))[props.currentIndex]
    }
    return props.history;
});

/**
 * 打开公平性原理弹框 
 */
const onHowItWorks = () => {
    // ↓ 委托父级处理开窗事件 
    emit('handlePrinciple');
};
/**
 * 检查，跳转打开hash校验页面
 */
const onCheck = () => {
    const address = import.meta.env.VITE_SHA265_CHECK_PAGE_URL;
    const message = oFairnessData.value.randomSeed;
    const url = `${address}/?message=${message}`;
    console.log('open page =', url); 
    window.open(url, '_blank');
};
/**
 * 点击输入框，全选内容
 * @param e 
 */
const handleSelectAll = (e) => {
    const currentDom = e.target;
    currentDom.setSelectionRange(0, currentDom.value.length);
}
watch(collapsed, (newVal) => {
    if (newVal) {
        props.fnScrollMove(330);
    }
});

const t = useTranslation();
</script>

